var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgChevronDown = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "20px",
    height: "20px",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Arrows/Chevron-down",
    stroke: "none",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.84194926,12.8408591 L5.1690283,8.44079226 C4.94365723,8.22858181 4.94365723,7.88453509 5.1690283,7.67234728 L5.71404972,7.15915256 C5.93903607,6.94730436 6.30367409,6.94689683 6.52918942,7.15824693 L10.250012,10.6453765 L13.9708106,7.15824693 C14.1963259,6.94689683 14.5609639,6.94730436 14.7859503,7.15915256 L15.3309717,7.67234728 C15.5563428,7.88455773 15.5563428,8.22860445 15.3309717,8.44079226 L10.6580748,12.8408591 C10.4327037,13.053047 10.0673203,13.053047 9.84194926,12.8408591 Z",
    id: "Path-Copy-5"
  }))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgChevronDown);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/chevron-down.5a3112e402e165a5ac0680cb573c90fb.svg";